export const COLORS = {
    primary: '#4a6fa5',
    secondary: '#6b8cae',
    accent: '#ff7e5f',
    light: '#f8f9fa',
    dark: '#343a40',
    text: '#495057'
  };